import request from '@/utils/request'
import requestFile from '@/utils/requestFile'

export function queryPageById(params) {
    return request({
        url: 'api/carInspectionComment',
        method: 'get',
        params
    })
}

export function queryPageByUserId(params) {
    return request({
        url: 'api/carInspectionComment/byUserId',
        method: 'get',
        params
    })
}

export function create(stationId, orderId, content, star, files) {
    var formData = new FormData();
    formData.append('stationId', stationId);
    formData.append('orderId', orderId);
    formData.append('content', content);
    formData.append('star', star);
    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i].file);
    }
    return requestFile({
        url: 'api/carInspectionComment',
        method: 'post',
        data: formData
    })
}

export function reply(data) {
    return request({
        url: 'api/carInspectionComment/reply',
        method: 'post',
        data
    })
}

export function del(id) {
    return request({
        url: 'api/carInspectionComment',
        method: 'delete',
        params: id
    })
}

/**
 * 查询是否已经评论
 * @param params
 * @returns {AxiosPromise}
 */
export function isComment(params) {
    return request({
        url: 'api/carInspectionComment/isComment',
        method: 'get',
        params
    })
}

export default {queryPageById, queryPageByUserId, create, reply, del,isComment}
